import connectedImg from './connected.png';
import disconnectedImg from './disconnected.png';
import disabledImg from './disabled.png';

export const connectedIcon = connectedImg;
export const disconnectedIcon = disconnectedImg;
export const disabledIcon = disabledImg;